/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoaTrustCertificateSubjectX500Principal
 */
export interface LoaTrustCertificateSubjectX500Principal {
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificateSubjectX500Principal
     */
    name?: string;
    /**
     * 
     * @type {Blob}
     * @memberof LoaTrustCertificateSubjectX500Principal
     */
    encoded?: Blob;
}

export function LoaTrustCertificateSubjectX500PrincipalFromJSON(json: any): LoaTrustCertificateSubjectX500Principal {
    return LoaTrustCertificateSubjectX500PrincipalFromJSONTyped(json, false);
}

export function LoaTrustCertificateSubjectX500PrincipalFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaTrustCertificateSubjectX500Principal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'encoded': !exists(json, 'encoded') ? undefined : json['encoded'],
    };
}

export function LoaTrustCertificateSubjectX500PrincipalToJSON(value?: LoaTrustCertificateSubjectX500Principal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'encoded': value.encoded,
    };
}

